/* eslint-disable no-unused-vars */
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsButton from '@cybs-ui/components/lib/button';
import { useDispatch, useSelector } from 'react-redux';
import './runSequenceComponent.scss';
import { useState } from 'react';
import {
  addConsoleLogValue,
  captureContext,
  loadGifComponent,
  loadStaticRequestResponse,
  paAuthEnrollment,
  paAuthSetup,
  paAuthValidate,
  updateButtonStatus
} from '../../redux/action/3ds-actions';
import ChallengeModal from '../challengeModal/ChallengeModal';
import DetailsComponent from '../detailsComponent/DetailsComponent';

function RunSequenceComponent() {
  const githubUrl = 'https://github.com/CyberSource?q=microform&type=all&language=&sort=';
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const {
    runSequences: sequenceValues,
    challengeCardChoosed: challengeCardChoosed,
    demoToolType: demoToolType
  } = useSelector((state) => state.runSeqReducer);
  const { logReducer } = useSelector((state) => state);
  const title = 'Request Sequence';
  const hostUrl = window.location.host;
  const xfRootPath =
    hostUrl.includes('apihub.visa.com') || process.env.NODE_ENV === 'development'
      ? 'https://developer.cas.cybersource.com'
      : '';
  let requestResponseXFPath;
  const clickHandler = (stage, subStage) => {
    if (stage === 1) {
      requestResponseXFPath = sequenceValues[stage - 1].staticRequestResponsePath;
      dispatch(
        loadStaticRequestResponse(
          stage,
          requestResponseXFPath,
          xfRootPath,
          challengeCardChoosed,
          demoToolType
        )
      );
      //dispatch(captureContext());
    } else if (stage === 2) {
      requestResponseXFPath =
        sequenceValues[stage - 1].subStages[subStage - 1].staticRequestResponsePath;
      dispatch(loadGifComponent(stage, subStage));
    } else if (stage === 3) {
      requestResponseXFPath = challengeCardChoosed
        ? sequenceValues[stage - 1].challengeCardStaticRequestResponsePath
        : sequenceValues[stage - 1].frictionlessCardStaticRequestResponsePath;
      //dispatch(paAuthSetup());
      dispatch(
        loadStaticRequestResponse(
          stage,
          requestResponseXFPath,
          xfRootPath,
          challengeCardChoosed,
          demoToolType
        )
      );
    } else if (stage === 4) {
      requestResponseXFPath = challengeCardChoosed
        ? sequenceValues[stage - 1].challengeCardStaticRequestResponsePath
        : sequenceValues[stage - 1].frictionlessCardStaticRequestResponsePath;
      //const form = document.getElementById('cardinal_collection_form');
      //form.submit();
      dispatch(
        loadStaticRequestResponse(
          stage,
          requestResponseXFPath,
          xfRootPath,
          challengeCardChoosed,
          demoToolType
        )
      );
    } else if (stage === 5) {
      requestResponseXFPath = challengeCardChoosed
        ? sequenceValues[stage - 1].challengeCardStaticRequestResponsePath
        : sequenceValues[stage - 1].frictionlessCardStaticRequestResponsePath;
      //dispatch(paAuthEnrollment());
      dispatch(
        loadStaticRequestResponse(
          stage,
          requestResponseXFPath,
          xfRootPath,
          challengeCardChoosed,
          demoToolType
        )
      );
    } else if (stage === 6) {
      requestResponseXFPath = sequenceValues[stage - 1].staticRequestResponsePath;
      dispatch(loadGifComponent(stage, undefined));
      // setShow(true);
    } else if (stage === 7) {
      requestResponseXFPath = sequenceValues[stage - 1].staticRequestResponsePath;
      dispatch(
        loadStaticRequestResponse(
          stage,
          requestResponseXFPath,
          xfRootPath,
          challengeCardChoosed,
          demoToolType
        )
      );
      //dispatch(paAuthValidate());
    }
    // dispatch(updateButtonStatus(stage));
  };
  const callbackModal = () => {
    // This function expects the POST response payload as input

    // The below data.authentication object is being constructed to mimic the POST response received at the return URL.
    // It is being simplified for demo purposes and should not be replicated for production use-cases.
    setShow(false);
    const paAuthEnrollmentStage = logReducer.logStages.find((stage) => {
      if (stage.stage === 5) return stage;
      return undefined;
    });
    const requestResponseObjet = {
      response: {
        title: '',
        body: undefined
      },
      request: {
        title: 'consumer authentication result',
        body: {
          TransactionId:
            paAuthEnrollmentStage.response.value.consumerAuthenticationInformation
              .authenticationTransactionId,
          Response: '',
          MD: 'null'
        }
      },
      decodedResponse: {
        title: undefined,
        value: undefined
      }
    };
    dispatch(addConsoleLogValue(requestResponseObjet, 6));
    dispatch(updateButtonStatus(6));
  };
  const [detailsModalState, setDetailsModalState] = useState(0);
  const openDetailsModal = (key) => {
    setDetailsModalState(key);
  };
  return (
    <>
      <CybsCard
        className="parallel-card"
        dataTest="requestsequence-card"
        header={<CybsActionBar dataTest="request-sequence-cardview" i18n={{ title }} />}
      >
        {Object.entries(sequenceValues).map((sequence) => {
          const buttonLabel = `${sequence[1].stage}. ${sequence[1].name}`;
          return (
            <div className="row container_sequence__button" key={sequence[1].stage}>
              <div className="col-lg-9">
                {sequence[1].stage !== 2 ? (
                  <CybsButton
                    dataTest={sequence[1].name}
                    colorScheme="secondary"
                    i18n={{ label: buttonLabel }}
                    disabled={sequence[1].disabled}
                    stagenum={sequence[1].stage}
                    key={sequence[1].stage}
                    onClick={() => clickHandler(sequence[1].stage)}
                    style={{ width: '100%' }}
                    aria-label={sequence[1].name}
                  />
                ) : (
                  <div className="side-cards">
                    <CybsButton
                      dataTest={sequence[1].subStages[0].name}
                      colorScheme="secondary"
                      i18n={{
                        label: `${sequence[1].stage}. ${sequence[1].name} ${sequence[1].subStages[0].name}`
                      }}
                      stagenum={sequence[1].stage}
                      disabled={sequence[1].subStages[0].disable}
                      key={sequence[1].subStages[0].num}
                      onClick={() => clickHandler(sequence[1].stage, sequence[1].subStages[0].num)}
                      style={{ width: '50%' }}
                      aria-label={sequence[1].subStages[0].name}
                    />
                    <CybsButton
                      dataTest={sequence[1].subStages[1].name}
                      colorScheme="secondary"
                      i18n={{
                        label: `${sequence[1].stage}. ${sequence[1].name} ${sequence[1].subStages[1].name}`
                      }}
                      stagenum={sequence[1].stage}
                      disabled={sequence[1].subStages[1].disable}
                      key={sequence[1].subStages[1].num}
                      onClick={() => clickHandler(sequence[1].stage, sequence[1].subStages[1].num)}
                      style={{ width: '50%' }}
                      aria-label={sequence[1].subStages[1].name}
                    />
                  </div>
                )}
              </div>
              <div className="col-lg-3">
                <CybsButton
                  dataTest="requestsequence-card__details"
                  colorScheme="tertiary"
                  key={sequence[1].stage}
                  i18n={{ label: 'Details' }}
                  onClick={() => {
                    openDetailsModal(sequence[1].stage);
                  }}
                  style={{ borderColor: 'white', color: '#2b6afd' }}
                />
                {detailsModalState !== 0 && detailsModalState === sequence[1].stage && (
                  <DetailsComponent
                    action={openDetailsModal}
                    detailsPath={xfRootPath.concat(sequence[1].detailsPath)}
                  />
                )}
              </div>
            </div>
          );
        })}
        <div className="row request_sequence__info">
          <div className="col-lg-8 request_sequence__info__text">Download our SDKs from Github</div>
          <div className="col-lg-4">
            <CybsButton
              dataTest="sample-code-button"
              i18n={{ label: 'Sample Code' }}
              onClick={() => window.open(`${githubUrl}`)}
              aria-label="Learn More about SDKs hosted on Github"
            />
          </div>
        </div>
      </CybsCard>
      <ChallengeModal display={show} closeModal={callbackModal} />
    </>
  );
}

export default RunSequenceComponent;
